import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import { SwitchInputV2Type } from './types';
import InputLabel from '../Inputs/InputLabel';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SwitchInputV2 = React.forwardRef<any, SwitchInputV2Type>(
  (
    {
      id,
      label,
      onChange,
      required = false,
      value = false,
      placeholder = '',
      loading = false,
      checkColor = 'primary',
      unCheckColor = 'gray-500',
      stopPropogation = false,
      isError,
      fieldState,
      span,
    }: SwitchInputV2Type,
    ref
  ) => {
    return (
      <div className="flex flex-row justify-start align-middle items-center">
        <div className="flex-col order-2 ms-2">
          {label && (
            <InputLabel text={label} name={id || ''} required={required} />
          )}
          <div className="text-textSecondary text-xs text-start">
            <ReturnTranslatedText
              origintext={span}
              text={`inputs.placeholders.${span}`}
            />{' '}
          </div>
        </div>
        <div
          onClick={(e) => {
            if (stopPropogation) {
              e.stopPropagation();
            }

            console.log('SwitchInputV2 onClick value:', value);
            const mappedValue = (!value || value === 'False') ? false : true;

            onChange && onChange(!mappedValue);
          }}
          className="order-1 relative inline-block w-10 my-auto align-middle select-none transition duration-200 ease-in"
        >
          <span
            className={`${
              value && value !== 'False'
                ? `border-green-500 ltr:right-0 rtl:left-0`
                : `border-red-500`
            } absolute w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer flex items-center justify-center`}
          >
            {loading && (
              <AiOutlineLoading3Quarters className="animate-spin text-primary" />
            )}
          </span>
          <label
            className={`block overflow-hidden h-6 rounded-full ${
              value && value !== 'False' ? ` bg-green-500` : `bg-red-500`
            } cursor-pointer`}
          ></label>
        </div>
        {isError && (
          <div className="absolute top-[105%] right-0 text-[12px] text-red-500">
            <ReturnTranslatedText
              origintext={fieldState?.error?.message}
              text={`general.${fieldState?.error?.message}`}
            />
          </div>
        )}
      </div>
    );
  }
);
